<template>
    <section>
        <TopBackgroundComponent/>
        <QualityIndicatorComponent/>
    </section>
</template>

<script setup>
    import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import QualityIndicatorComponent from '../components/indicators/QualityIndicatorComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
  /*  */
</style>